import React, {Component} from 'react';
import {withTranslation} from 'next-i18next';
import PropTypes from 'prop-types';

class Placeholder extends Component {
	static propTypes = {
		img: PropTypes.string,
		text: PropTypes.string,
		displayText: PropTypes.bool,
		'data-testid': PropTypes.string,
	};

	static defaultProps = {
		img: 'nocontent',
		text: '',
		displayText: true,
	};

	renderText() {
		const {text, displayText, t} = this.props;

		if (!displayText) {
			return null;
		}

		if (text !== '') {
			return <div className="placeholder-text">{text}</div>;
		}

		return (
			<div className="placeholder-text">
				<p>
					<strong>
						{t('deliverymonitoring_title_itslookingquietaroundhere_d4c-web')}
					</strong>
				</p>
				<p>{t('deliverymonitoring_text_wehelpfindsomethingelse_d4c-web')}</p>
			</div>
		);
	}

	render() {
		return (
			<div
				className="placeholder-container"
				data-testid={this.props['data-testid']}
			>
				<div className={`placeholder-img ${this.props.img}`} />
				{this.renderText()}
			</div>
		);
	}
}

export default withTranslation('d4c')(Placeholder);
